import React from "react";
import TwoColumnLayout from "../../../layout/TwoColumnLayout";
import FlightDetailOutsideModal from "./FlightDetails";
import FlightOptionsPanel from "./FlightOptionsPanel";
import PanelSegmentType from "components/panels/PanelSegment/PanelSegment";
import { useLoaderData } from "react-router";
import FlightApp from "flights/new/app";

const FlightDetailPage = () => {
  const viewModel = useLoaderData<server.viewmodel.FlightDetailFrontModel>();

  return <>
    <FlightApp />
    <PanelSegmentType>
      <PanelSegmentType.Header size="h2header">
        <PanelSegmentType.Title title={RESX.Flight.resxFlight} />
      </PanelSegmentType.Header>
    </PanelSegmentType>

    <TwoColumnLayout>
      <TwoColumnLayout.LeftColumn>
        <FlightDetailOutsideModal
          initialFlight={viewModel.flight}
        />
      </TwoColumnLayout.LeftColumn>
      <TwoColumnLayout.RightColumn>
        <FlightOptionsPanel
          flight={viewModel.flight}
          canCopy={viewModel.canCopy}
          optionsPanelData={viewModel.optionsPanel}
          listUrl={viewModel.listUrl}
        />
      </TwoColumnLayout.RightColumn>
    </TwoColumnLayout>
  </>;
};

export default FlightDetailPage;